import { useCallback, useRef, useState } from "react";
import { Form, type FormInstance } from "antd";

export function usePasswordReveal(form: FormInstance) {
  const [formFocused, setFormFocused] = useState(false);
  const blurTimeout = useRef<ReturnType<typeof setTimeout>>();
  const emailValue = Form.useWatch("email", form);
  // Fall back to reading the form store directly for the initial value
  // (useWatch may return undefined on first render before the form store hydrates)
  const emailInitial =
    (form.getFieldValue("email") as string | undefined) ?? "";
  const isPasswordVisible = formFocused || !!(emailValue ?? emailInitial);

  const handleFieldFocus = useCallback(() => {
    clearTimeout(blurTimeout.current);
    setFormFocused(true);
  }, []);

  const handleFieldBlur = useCallback(() => {
    blurTimeout.current = setTimeout(() => setFormFocused(false), 100);
  }, []);

  return { isPasswordVisible, handleFieldFocus, handleFieldBlur };
}
